import { createModel } from '@rematch/core';
import { RootModel } from '../rootModel';

// Leer el valor inicial de collapsed desde localStorage
const collapsedFromStorage = typeof window !== 'undefined' && localStorage.getItem('sidebarCollapsed') === 'true';

export const menuDrawer = createModel<RootModel>()({
	state: {
		open: false,
		selectedIndex: 0,
		collapsed: collapsedFromStorage || false,
	} as Imenu,
	reducers: {
		toogleMenu(state) {
			return{
				...state,
				open: !state.open,
			}
		},
		activeMenu(state) {
			return{
				...state,
				open: true
			}
		},
		closeMenu(state) {
			return{
				...state,
				open: false
			}
		},
		changeSelectedIndex(state, index:number){
			return{
				...state,
				open: false,
				selectedIndex: index
			}
		},
		toggleCollapsed(state) {
			const newCollapsed = !state.collapsed;
			if (typeof window !== 'undefined') {
				localStorage.setItem('sidebarCollapsed', newCollapsed ? 'true' : 'false');
			}
			return {
				...state,
				collapsed: newCollapsed
			};
		},
		setCollapsed(state, value: boolean) {
			if (typeof window !== 'undefined') {
				localStorage.setItem('sidebarCollapsed', value ? 'true' : 'false');
			}
			return {
				...state,
				collapsed: value
			};
		}
	},
});

interface Imenu {
	open: boolean;
	selectedIndex: number;
	collapsed: boolean;
}
